import { render, staticRenderFns } from "./ChatSettingCache.vue?vue&type=template&id=cfe4891e&"
import script from "./ChatSettingCache.vue?vue&type=script&lang=js&"
export * from "./ChatSettingCache.vue?vue&type=script&lang=js&"
import style0 from "./ChatSettingCache.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports